import * as React from 'react';
import {
  Field,
  FieldRenderProps,
} from '@practicegenius/react-final-form/src/Field';
import {Input} from './Input';

type $ObjMap<T extends {}, F extends (v: any) => any> = {
  [K in keyof T]: F extends (v: T[K]) => infer R ? R : never;
};

type FieldProps = React.ComponentProps<typeof Field>;

type FieldInputProps<T extends React.ComponentType<any>> = Omit<
  React.ComponentProps<T>,
  keyof $ObjMap<FieldRenderProps['input'], () => any>
> & {
  type?: string;
  name?: FieldProps['name'];
  validate?: FieldProps['validate'];
  initialValue?: FieldProps['initialValue'];
  format?: FieldProps['format'];
  parse?: FieldProps['parse'];
  // This component needs to be refactored to allow for the caller of this to pass in a
  // function to render the element instead of doing the rendering here
  // TODO ⏫
  component?: T;
  // This is a catch-all to allow any extra props to be passed in. Related to the above TODO
  [k: string]: any;
};

/**
 * Light layer on top of Field + Input to eliminate render function boilerplate
 * Works for 90% of use cases. Use Field + Input if this doesn't satisfy your needs!
 */
export function FieldInput<ComponentType extends React.ComponentType<any>>({
  name,
  initialValue,
  validate,
  // @ts-ignore
  component: Component = Input,
  type,
  format,
  parse,
  ...otherProps
}: FieldInputProps<ComponentType>) {
  const fieldProps = {
    name: name as string,
    validate,
    initialValue,
    type,
    format,
    parse,
  };

  return (
    <Field {...fieldProps}>
      {({input, meta}): React.ReactNode => (
        // @ts-ignore
        <Component {...otherProps} {...input} error={meta.displayError} />
      )}
    </Field>
  );
}
